import type { WidgetMode } from '../constants';
import { SUBMIT_FORM_INTENT } from '../constants';

export const getSuccessNotification = (hangingProtocolName: string, mode: WidgetMode): string => {
  let modeMessage = '';
  switch (mode) {
    case SUBMIT_FORM_INTENT.SAVE: {
      modeMessage = 'Created';
      break;
    }
    case SUBMIT_FORM_INTENT.UPDATE: {
      modeMessage = 'Updated';
      break;
    }
  }

  return `${modeMessage} hanging protocol: ${hangingProtocolName}.`;
};
